<template lang="pug" >
//- div 44444
el-button(type="primary" @click="open") 主要按钮
</template>

<script>
export default {
  props: {
    // 流程信息
    flowMessage: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {

    };
  },
  methods: {
    open() {
      console.log(this.flowMessage);
      debugger;
    }
  }

};
</script>

<style>

</style>
